import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { API_URL, URL_IMAGE } from "../services/api/config";
import { api } from "../services/api/api.index";
import { Link, useLocation, useParams } from "react-router-dom";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaLongArrowAltRight } from "react-icons/fa";
import moment from "moment";
import OverlaySpinner from "../components/overlaySpinner/OverlaySpinner";
import { LazyLoadImage } from "react-lazy-load-image-component";
import NewSlider from "../components/slider/NewSlider";
import { Helmet } from "react-helmet";
const BlogLevel2Screen = () => {
  const [dataSource, setDataSource] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const abc = useLocation();
  const getDataBlogs = async () => {
    setLoading(true);
    try {
      let { data, metadata } = await api.get(
        `${API_URL}api/v1/blogs/external/${params?.id}%2F${params?.idlevel1}%2F${params?.idlevel2}`,
        {
          status: "ACTIVE",
          depth: 3,
        }
      );
      setDataSource(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getDataBlogs();
  }, [params]);
  // useEffect(() => {
  //   if (state?.level === 0) {
  //     setParentState(state);
  //   }
  // }, [state]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="blogs__bread" style={{ marginTop: "36px" }}>
      <OverlaySpinner open={loading} text={""} />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{dataSource?.name}</title>
        <meta name="description" content={dataSource?.name} />
      </Helmet>
      <h4 className="breadcrumbCss">
        <Link to="/">Trang chủ</Link> / <Link to="/blogs">Blog</Link> /&nbsp;
        <Link to={`/blogs/${dataSource?.parent_info?.parent_info?.url_path}`}>
          {dataSource?.parent_info?.parent_info?.name}
        </Link>
        &nbsp; /&nbsp;
        <Link to={`/blogs/${dataSource?.parent_info?.url_path}`}>
          {dataSource?.parent_info?.name}
        </Link>
        &nbsp; /&nbsp; {dataSource?.name}
      </h4>

      <div className="blogs__items">
        <div className="blogs__subBlock mobilecenter ">
          <div className="blogs__subBlock__image">
            <LazyLoadImage
              src={`${URL_IMAGE}` + dataSource?.image_url}
              href="block2"
            />
          </div>

          <div className="blogs__subBlock__content">
            <div className="blogs__subBlock__content__time">
              <FaRegCalendarAlt />
              &nbsp;
              {moment(dataSource?.created_at).format("HH:mm DD/MM/YYYY")}
            </div>
            <div
              className="blogs__subBlock__content__des"
              dangerouslySetInnerHTML={{
                __html: dataSource?.content,
              }}
            ></div>
            {dataSource?.images?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "16px",
                  width: "100%",
                }}
              >
                <NewSlider dataSource={dataSource} />
              </div>
            )}
            {dataSource?.sub_content && (
              <div
                className="blogs__subBlock__content__des"
                dangerouslySetInnerHTML={{
                  __html: dataSource?.sub_content,
                }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogLevel2Screen;
